import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BarbersService } from '../barbers/barbers.service';
import { environment } from 'src/environments/environment';
import { SliceQuery, SliceInsertQuery, SliceUpdateQuery } from '../api/api.defs';
import { ShiftsRow, ShiftsStatusRow } from './shifts.defs';
import { map } from 'rxjs/operators';
import { DAYS_TO_FIELDS } from '../shared/DAYS_TO_FIELDS';
import { defuckTime } from '../shared/defuckTime';
import { BarberRow } from '../barbers/barber';
import { OfflineService } from '../api/offline.service';
// import { ApplicationStore, DaysToFields } from '../app.store';

@Injectable({
	providedIn: 'root'
})
export class ShiftsService {

	private _statusRows: ShiftsStatusRow[];

	constructor(
		private _api: ApiService,
		private _barbers: BarbersService,
		private _offline: OfflineService,
	) { }

	checkDate(date: Date = new Date()) {
		const key = `shifts.byDay.${this._offline.dateAsString(date)}`;
		return this._api
			.request<{
				shifts: SliceQuery<ShiftsRow>,
				barbers: SliceQuery<BarberRow>,
			  }>({
				'shifts': {'$/slice/report': {slice: environment.slices.shifts, where: ['$eq', ['$date', ['$field', 'START']], ['$date', date]]}},
				'barbers': {'$/slice/report': {slice: environment.slices.barbers, where: ['$empty', ['$field', 'isSystem_0']]}}
			}, key)
			.pipe(
				map(resp => {
					const shifts = resp.shifts.rows;
					return !!(resp.barbers.rows.filter(barber => !(shifts.some(shift => shift.BARBERRef === barber.id))).length)
				})
			);
  	}

	byDay(d: Date) {
		const date = new Date(d);
		let statusRows = this._statusRows;
		date.setHours(0,0,0,0);
		const req: {shifts: Object, status?: Object} = {
				shifts: {'$/slice/report': {
					slice: environment.slices.shifts,
					where: ['$and',
						['$eq', ['$date', ['$field', 'START']], ['$date', date]],
						['$empty', ['$field', 'BARBER:isSystem_0']]
					]
				}},
			},
			key = `shifts.byDay.${this._offline.dateAsString(date)}`;
		if (!this._statusRows) {
			req.status = {'$/slice/report': {slice: environment.slices.shiftStatus}};
		}		
		return this._api
			.request<{shifts: SliceQuery<ShiftsRow>, status?: SliceQuery<ShiftsStatusRow>}>(req, key)
			.pipe(
				map(resp => {
					if (resp.status && resp.status.rows) {
						statusRows = this._statusRows = resp.status.rows;
					}
					const shifts = resp.shifts.rows,
						barbers = this._barbers.all.getValue().filter(b => !b.system),
						weekday = date.getDay(),
						scheduledStatus = statusRows.find(s => s.available_0).id,
						offStatus = statusRows.find(s => s.off_0).id,
						tmpStart = new Date(date),
						tmpEnd = new Date(date),
						scheduled: {[id: number]: ShiftsRow} = {};

					tmpStart.setHours(0,0,0,0);
					tmpEnd.setHours(23,59,0,0);
					const rows = barbers.map(barber => {
						const s = shifts.find(shift => shift.BARBERRef === barber.id);
						let shift: ShiftsRow;
							if (s) {
								shift = s;
							} else {
								const schedule = barber.schedule.get(weekday);
								if (schedule.start && schedule.end) {
									shift = {
										BARBERRef: barber.id,
										STATUSRef: scheduledStatus,
										START: schedule.start,
										END: schedule.end,
									}
								} else {
									shift = {
										BARBERRef: barber.id,
										STATUSRef: offStatus,
										START: tmpStart,
										END: tmpEnd,
										_startedOff: true,
									}
								}
							}
							scheduled[barber.id] = Object.assign({}, shift);
							return shift;
						}),
						valid = this.checkValidity(rows, statusRows);
					return {
						shifts: rows,
						statusRows,
						scheduled,
						valid,
						barbers
					}
				})
			)
	}

	checkValidity(shifts: ShiftsRow[], status: ShiftsStatusRow[]): boolean {
		shifts = shifts
			.map(shift => {
				const original = status.find(s => s.id === shift.STATUSRef);
				shift._invalid = original.requiresTime_0 && (!shift.START || !shift.END || shift.START > shift.END);
				shift._requiresTime = original.requiresTime_0;
				return shift;
			});
		return !shifts.some(shift => shift._invalid);
	}

	// 	return new Promise<string | null>((res) => {
	saveShifts(rows: ShiftsRow[], statusRows: ShiftsStatusRow[], d: Date, defaults:  {[id: number]: ShiftsRow} ) {
			const ins: any[] = [],
				upd: any[] = [],
				ign: any[] = [],
				n = new Date(),
				isToday = n.getFullYear() === d.getFullYear() && d.getMonth() === n.getMonth() && d.getDate() === n.getDate();

			rows.forEach(row => {
				const shift = Object.assign({}, row), // operate on a clone
					initial = defaults[shift.BARBERRef],
					changed = initial && initial.STATUSRef !== shift.STATUSRef || initial.START.getTime() !== shift.START.getTime() || initial.END.getTime() !== shift.END.getTime(),
					status = statusRows.find(s => s.id === shift.STATUSRef);

				if (shift.id && changed) { // anything existing with a change on it, gets saved.. 
					upd.push(shift);
				} else if (isToday && !shift.id) { // anything new, for today, gets save
					ins.push(shift);
				} else {
					if (!changed || (shift._startedOff && status.off_0)) {
						ign.push(shift);
					} else { // otherwise, something has changed
						ins.push(shift);
					}
				}
			})
			const reqs: {insert?: any, update?: any} = {};
			if (upd.length) {
				reqs.update = {'$/slice/xupdate': {
					slice: environment.slices.shifts,
					rows: upd,
				}};
			}
			if (ins.length) {
				reqs.insert = {'$/slice/xinsert': {
					slice: environment.slices.shifts,
					rows: ins,
				}};
			}
			if (reqs.insert || reqs.update) {
				return this._api
					.request<{
						insert: SliceInsertQuery,
						update: SliceUpdateQuery,	
					}>(reqs)
			}
			return null;
	}
}
